import api from './api.js';
import decode from 'jwt-decode';

export default {
  login(username, password, cb) {
    cb = arguments[arguments.length - 1]
    api.getToken(username, password, (res) => {
      if (res.token) {
        localStorage.token = res.token
        if (cb) cb(true)
        this.onChange(true)
      } else {
        if (cb) cb(false)
        this.onChange(false)
      }
    });
  },
  logout(cb) {
    localStorage.token = ""
    delete localStorage.token
    if(cb) cb()
    this.onChange(false)
  },
  loggedIn() {
    var token = localStorage.token;
    var expired = tokenExpired(token);

    if(expired) {
      delete localStorage.token;
      return false;
    }

    return !!token;
  },
  admin() {
    var token = localStorage.token;
    return !!token && tokenAdmin(token);
  },
  groupAdmin() {
    var token = localStorage.token;
    return !!token && tokenGroupAdmin(token);
  },
  onChange() {},
}

function tokenAdmin(encodedToken) {
  try {
    const token = decode(encodedToken);
    if (!token.admin) { return false; }
    return token.admin;
  } catch(error) {
    console.log(error);
    return false;
  }
}

function tokenGroupAdmin(encodedToken) {
  try {
    const token = decode(encodedToken);
    return !!token.group_admin;
  } catch(error) {
    console.log(error);
    return false;
  }
}

function tokenExpired(token) {
  const expirationDate = tokenExpirationDate(token);
  return expirationDate < new Date();
}

function tokenExpirationDate(encodedToken) {
  try {
    const token = decode(encodedToken);
    if (!token.exp) { return null; }
    const date = new Date(0);
    date.setUTCSeconds(token.exp);
    return date;
  } catch(error) {
    console.log(error);
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/auth.js